export default "__VITE_ASSET__CjaGc3cS__"